var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item-wrapper",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"mi-img"},[_vm._t("img")],2),_c('div',{staticClass:"mi-hl"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"mi-descr"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }